const myCartTypes = {
    MY_CART_ACTION_TYPE: "MY_CART_ACTION_TYPE"
}

export { myCartTypes };